import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { TransactionInfoModel } from '../../cmg-1003/models';

import { Cmg1003TransactionStore } from './transaction.store';
import { DirtyChecker2 } from '../core/dirty-checker-2';

@Injectable({ providedIn: 'root' })
export class Cmg1003TransactionQuery extends Query<TransactionInfoModel> {
  protected store: Cmg1003TransactionStore;

  static instance: Cmg1003TransactionQuery;
  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);
  constructor() {
    const store = inject(Cmg1003TransactionStore);

    super(store);
    this.store = store;

    Cmg1003TransactionQuery.instance = this;
  }

  assembleForSave() {
    const storeValue = this.getValue();
    const saveModel: Partial<TransactionInfoModel> = {
      alterationsImprovementsAndRepairsAmount: storeValue?.alterationsImprovementsAndRepairsAmount,
      landValueType: storeValue?.landValueType,
      landOriginalCostAmount: storeValue?.landOriginalCostAmount,
      discountPoints: storeValue?.discountPoints,
      brokerCommitmentFee: storeValue?.brokerCommitmentFee,
      brokerFee: storeValue?.brokerFee,
      commitmentFee: storeValue?.commitmentFee,
      mortgageBrokerFee: storeValue?.mortgageBrokerFee,
      originationFee: storeValue?.originationFee,
    };
    return saveModel;
  }
}
